export default __webpack_public_path__ + "static/media/532.9a8d78d7.png";